import { render, staticRenderFns } from "./CreateMovement.vue?vue&type=template&id=61c8b41c&scoped=true"
import script from "./CreateMovement.vue?vue&type=script&lang=ts"
export * from "./CreateMovement.vue?vue&type=script&lang=ts"
import style0 from "./CreateMovement.vue?vue&type=style&index=0&id=61c8b41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8b41c",
  null
  
)

export default component.exports